import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";

export const SortContainer = styled.div<{sort?:boolean}>`
    display:inline-block;

    svg{
        height:12px !important;
        transform: rotateX(${props => props.sort?"180deg":"0deg"});
    }
`;